<template lang="pug">
    div
        crud-form(:fields="fields" noButtons)
            template(slot="appendContent")
                v-divider.mb-3
                v-layout(wrap)
                    v-flex.xs6.d-flex
                        v-form(ref="form") 
                          integer-input.pr-3(
                              box
                              prefix="$"
                              max-length="12"
                              v-model="max_customer_credit_amount"
                              :rules="[v => !!v || 'Campo Obligatorio']"
                              :disabled="loading"
                              )
                                template( slot='prepend-inner' )
                                    span Cupo $
                        v-tooltip(top)
                          v-btn.ma-0.mt-1(
                            slot="activator"
                            block
                            large
                            @click="confirmCreditUpdate"
                            color="secondary"
                            ) Actualizar Cupo
                          span Actualizar Cupo Máximo
                    v-flex.xs6.d-flex.justify-end
                        v-switch.mr-4.mt-2(
                            label="Cobranza Automática"
                            style="max-width: 250px;"
                            v-model="flag_send_debt_email"
                            :disabled="loading"
                            )
                        v-btn(
                            :color="btnColor"
                            dark
                            @click="toggleLock"
                            style="max-width: 200px;"
                            ) {{btnText}}
                            v-icon(
                                dark
                                right
                                ) {{btnIcon}}
</template>

<script>
/* components */
import { CrudForm, InputButton } from '@/components/reusable_components'
import IntegerInput from '../../../components/reusable_components/Input/FloatInput.vue'
import fields from './fields/CommercialInfoFields.js'
/* services */
import CustomerService from '@/services/api/customer'
/* vuex */
import { mapActions, mapState } from 'vuex'
/* mixins */
import snackbarModalUtils from '../../../mixins/reusable_mixins/SnackbarModalUtils'
import SlCustomer from '@/models/Sale/SlCustomer'
export default {
    name: 'commercial-info',
    props: {},
    data: function() {
        return {
            fields: fields,
            data: {},
            blocked: false,
            loading: false,
            flag_send_debt_email: false,
            max_customer_credit_amount: 0,
        }
    },
    computed: {
        btnIcon() {
            return this.blocked ? 'lock_open' : 'lock_outline'
        },
        btnText() {
            return this.blocked ? 'desbloquear' : 'bloquear'
        },
        inputString() {
            return this.blocked ? 'bloqueado' : 'desbloqueado'
        },
        btnColor() {
            return this.blocked ? 'success' : 'red'
        },
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        async getCustomerData() {
            let customer = await CustomerService.findById(this.$route.params.id)
            let fields = [...this.fields]
            this.data = customer
            const fullname = employee => {
                return employee.names + ' ' + employee.last_name1
            }

            fields[0].value = customer.discount
            /*fields[1].value = customer.sl_ground_seller[0]
                ? fullname(customer.sl_ground_seller[0].hr_employee)
                : 'Sin vendedor'*/
            fields[1].value = customer.pch_payment_condition.type
            fields[2].value =
                customer.blocked_sales === true ? 'Bloqueado' : 'Desbloqueado'
            this.blocked = this.data.blocked_sales
            this.flag_send_debt_email = customer.flag_send_debt_email
            this.fields = [...fields]
            this.max_customer_credit_amount =
                customer.max_customer_credit_amount
        },
        async toggleLock() {
            let data = { ...this.data }
            let payload = this.getPayloadForBlockUnblockCustomer()

            this.loading = true
            let response = await CustomerService.blockUnblockCustomer(payload)
            this.snackResponseSubmit(
                response,
                'Cliente actualizado correctamente'
            )
            if (response.status === 200) {
                this.$router.go()
            }
            //this.data = response
        },
        /**
         */
        getPayloadForBlockUnblockCustomer() {
            let dataForm = { ...this.data }
            let payload = {}
            payload.sl_customer_id = dataForm.id
            payload.blocked_sales = !this.blocked
            return payload
        },
        showSnackbar(type, title, message, callback = () => {}) {
            //
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack(type, title, message, false, 0))
            callback()
        },
        async toggleSendDebtMail() {
            this.loading = true
            let flag = this.flag_send_debt_email
            this.resetSnackbarState()
            let customer = new SlCustomer({ ...this.data })
            customer.flag_send_debt_email = this.flag_send_debt_email
            try {
                let response = await customer.save()
                this.loading = false
                this.data.flag_send_debt_email = flag
                this.flag_send_debt_email = flag
                this.showSnackbar(
                    'success',
                    'Éxito',
                    `Cobranzas automáticas ${flag ? '' : 'des'}habilitadas`
                )
            } catch (e) {
                this.loading = false
                this.showSnackbar(
                    'error',
                    'Error',
                    e.response.data.message ||
                        e.response.data.error ||
                        'Ha ocurrido un error'
                )
            }
        },
        confirmCreditUpdate() {
            this.showSnackbar(
                'warning',
                `CUPO MÁXIMO`,
                '¿Modificar el Cupo Máximo para este cliente?',
                () => this.setMessageConfirmSnack('Actualizar Cupo')
            )
        },
        updateMaxCredit() {
            if (!this.$refs.form.validate()) return
            this.loading = true
            this.data
                .updateCustomerMaxCreditAmount(this.max_customer_credit_amount)
                .then(() => {
                    this.showSnackbar('success', 'Éxito', 'Cupo Actualizado')
                    //this.$router.go()
                })
                .catch(e =>
                    this.showSnackbar(
                        'error',
                        'Error',
                        e.response.data.message ||
                            e.response.data.error ||
                            'Ha ocurrido un error'
                    )
                )
                .finally(() => (this.loading = false))
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        flag_send_debt_email(v) {
            if (v === this.data.flag_send_debt_email)
                return this.resetSnackbarState()
            this.showSnackbar(
                'warning',
                `COBRANZA AUTOMÁTICA`,
                `¿${
                    v ? 'Habilitar' : 'Deshabilitar'
                } cobranza automática para este cliente?`,
                () =>
                    this.setMessageConfirmSnack(
                        v ? 'habilitar' : 'deshabilitar'
                    )
            )
        },

        async responseConfirm(message) {
            if (['habilitar', 'deshabilitar'].includes(message))
                await this.toggleSendDebtMail()
            if (message === 'Actualizar Cupo') this.updateMaxCredit()
        },
    },
    components: {
        'crud-form': CrudForm,
        'input-button': InputButton,
        'integer-input': IntegerInput,
    },
    mixins: [snackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: async function() {
    //     await this.getCustomerData()
    // },
    // beforeMount: function(){...},
    mounted: async function() {
        await this.getCustomerData()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.block-field {
    margin-top: -84px;
}
.btn_position {
    margin-left: 75%;
}
</style>
